import ConfigureSurveyAssessment from './ConfigureSurveyAssessment';

export default ConfigureSurveyAssessment;
